<template>
    <li>
        <div class="title"><span>オーダー</span></div>
        <div class="detail form_checkbox">

            <template v-for="(order, index) in orderList" v-bind:key="index">
                <input type="checkbox" name="edit-order" class="" :id="'edit-order' + index" v-on:change="changeOrder(order, index)" v-bind:checked="order.checked">
                <label :for="'edit-order' + index">
                    <div class="check-mark"><span></span></div>
                    <span>{{ order.name }}</span>
                </label>
            </template>

        </div>
    </li>
</template>

<script>
    export default {
        data() {
            return {
                orders: [],
            }
        },
        computed: {
            orderList(){
                return this.$store.state.register.set.order;
            },
            // プレビューのために並び替え
            sortedItemsByOrders(){
                return this.orders.sort((a, b) => {
                    return (a.id < b.id) ? -1 : (a.id > b.id) ? 1 : 0;
                });;
            }
        },
        mounted() {
            if (this.$store.state.detail.set.brand.orders) {
                this.orders = this.$store.state.detail.set.brand.orders;
                this.$store.state.register.form.order = this.$store.state.detail.set.brand.orders;
                for(var i in this.$store.state.register.set.order) {
                    var order = this.$store.state.register.set.order[i];

                    // 選択されたデータがあればcheckedをもたせる
                    if (this.$store.state.detail.set.brand.orders.some(detail_order => detail_order.id == order.id)) {
                        this.$store.state.register.set.order[i].checked = true;
                    } 
                }
            }
        },
        methods: {
            changeOrder(value, index) {

                // 重複しているインデックス番号を取得
                var check_index = this.orders.findIndex(order => order.id === value.id);

                if(check_index != -1) {
                    this.orders.splice(check_index, 1);
                } else {
                    this.orders.push(value);
                }

                this.$store.state.register.form.order = this.sortedItemsByOrders;
            }
        }
    }
</script>